import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from "../../../../../../../../../../../../components/button";
import Icon from "../../../../../../../../../../../../components/icon";
import Input from '../../../../../../../../../../../../components/input';

function ContactEditPhoneRow (props) {
    const { t } = useTranslation();


    return (
        <div className={`contact-edit-phone-row d-flex py-2 mb-1`}>
            <div className="col-1 d-flex align-items-center justify-content-center">
                {
                    props.index
                        ?
                        props.index === 0
                            ?
                            <svg width="20" height="20" viewBox="0 0 24 24">
                                <path fill="none" d="M0 0h24v24H0V0z"/>
                                <path
                                    d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"/>
                            </svg>
                            :
                            ''
                        :
                        <svg width="20" height="20" viewBox="0 0 24 24">
                            <path fill="none" d="M0 0h24v24H0V0z"/>
                            <path
                                d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"/>
                        </svg>
                }
            </div>
            <div className="col-5">
                <input
                    type="phone"
                    className="form-control"
                    name={t("registerScreenFormUserPhone")}
                    id={`phone-${props.index}`}
                    defaultValue={props.phoneNumber.number}
                    placeholder={t("registerScreenFormUserPhone")}
                    autoComplete={'' + Math.random()}
                />
            </div>
            <div className="col-5">
                <Input
		            id={`phone-label-${props.index}`}
		            list={`phone-label-list-${props.index}`}
		            name="phone-label"
		            defaultValue={props.phoneNumber.label}
                    placeholder={t("fieldLabelPlaceholder")}
	            />
	            <datalist id={`phone-label-list-${props.index}`}>
		            <option value={t("fieldLabelWork")}/>
		            <option value={t("fieldLabelHome")}/>
		            <option value={t("fieldLabelOther")}/>
	            </datalist>
                {/*<select id={`phone-label-${props.index}`} name="phone-label" className="form-control" defaultValue={props.phoneNumber.label}>
		            <option value="work">Work</option>
		            <option value="home">Home</option>
		            <option value="other">Other</option>
	            </select>*/}
            </div>
            <div className="col-1 d-flex align-items-center justify-content-center">
                {
                    props.index === 0
                        ?
                        <Button className="btn-link p-0 add" onClick={props.newPhoneRow}>
                            <Icon name="plus-circle"/>
                        </Button>
                        :
                        null
                }
                {
                    props.index > 0
                        ?
                        <Button data-index={props.index} className="btn-link p-0 delete" onClick={props.deletePhoneRow}>
                            <Icon name="times"/>
                        </Button>
                        :
                        null
                }
            </div>
        </div>
    );
}

export default ContactEditPhoneRow;
